<template>
	<div class="fileTagPopUp w-full">
		<FileTagPopUp
			:active.sync="tagPopupActive"
			:file="selectedFile"
			@close="tagPopupActive = false"
      @updateModel="updateModel"
			:tags="tags"
			:file-tags="fileTags"
		/>


		<vx-card class="stages-files">
			<div class="stages-files__title mb-3">
				<b>{{ $t("filesFromClient") }}</b>
			</div>

			<div class="stages-files__list">
				<div class="client-files-block">
					<div class="vx-row client-files-list">
						<div
							v-for="(file, fileIndex) in model.files"
							:key="fileIndex"
							class="vx-col flex column stage__file"
						>
							<div
								style="border-top: #e4e4e4 1px solid;"
								class="pt-4 stage__file-container"
								@click="e => openImagePopup(e, file)"
							>
								<FileNameView
									:orderId="orderId"
									:file="file"
									:url="file.url"
									@fileDeleted="updateModel"
									:createdAt="file.created_at"
								/>

							</div>
							<div class="flex justify-between tag_container">

								<div class="tags_for_file flex flex-wrap px-2 gap-2">
									<template v-if="file.tags && file.tags.length > 0">
										<div v-for="tag in file.tags" :key="tag.id" class="tag">
											{{ getLocalizedTagName(tag) }}
										</div>
									</template>
									<template v-else>
										<div>No tags.</div>
									</template>
								</div>


								<div>
									<vs-button
                    v-if="['admin', 'manager'].indexOf(userRole) !== -1"
										color="success"
										class="text-sm p-2"
										@click="openTagPopup(file)"
									>
										{{ $t('addTag') }}
									</vs-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</vx-card>
	</div>
</template>

<script>
import FileNameView from "@/views/Tickets/FileNameView";
import VSelect from 'vue-select'
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import FileTagPopUp from "@/components/managers/FileTagPopUp.vue";

export default {
	name: "ClientFiles",
	mixins: [databaseManager, notifier],
	components: {
		FileTagPopUp,
		FileNameView,
		VSelect
	},

	props: {
		orderId: {type: Number},
		model: { default: () => ({}) },
		sending: {type: Boolean},
		orderStatus: {type: String, default: ""}
	},

	data() {
		return {
			imagePopupActive: false,
			imagePopupFile: null,
			loading: false,

			tagPopupActive: false,
			selectedFile: null,

			tags: [],

			fileTags: {},

			currentLanguage: localStorage.getItem('locale'),
		};
	},

	computed: {
		autoSending: {
			currentLanguage() {
				return localStorage.getItem('locale');
			},
			get() {
				return this.sending;
			},
			set(value) {
				this.$emit("update:sending", value);
			}
		},
	},

	methods: {
		openImagePopup(e, file) {
			this.$emit("openImagePopup", e, file);
		},

		async updateModel() {
			this.$emit("updateModel");
		},



		async openTagPopup(file) {
			this.selectedFile = file;
			this.fileTags = {
				[file.id]: file.tags || []
			};
			this.tagPopupActive = true;
		},


		getLocalizedTagName(tag) {
			const key = `name_${this.currentLanguage}`;
			return tag[key] || tag.name_en || "No name";
		}


	},

  async mounted() {
    const userRole = this.$store.state.auth.role;
    if (userRole !== 'author') {
      const genre = 'client_file';
      const fetchedTags = await this.dbGetTags(genre);

      this.tags = fetchedTags.map(tag => ({
        id: tag.id,
        name_en: tag.name_en,
        name_ru: tag.name_ru,
        name_de: tag.name_de,
      }));
    }
  }
};
</script>

<style lang="scss">
.tags_for_file {
	max-width: 80%;
}
.tag {
	background-color: #e2e8f0;
	border-radius: 5px;
	padding: 5px 10px;
	display: inline-block;
}

.fileTagPopUp {
	white-space: normal;
	word-break: break-word;

	.stage__file,
	.fileName,
	.client-files-block,
	.client-files-list {
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: break-word;
	}
}

.stages-files {
	margin-top: 20px;

	&__list {
		display: grid;
		grid-row-gap: 10px;

		.stage {
			padding-top: 15px;
			padding-bottom: 15px;
			border-top: #e4e4e4 1px solid;
			min-width: 0;


			&:first-child {
				border-top: none;
				padding-top: 5px;
			}

			&__file {
				margin-top: 10px;
				width: 100%;

				&-container {
					display: flex;
					align-items: center;
					justify-content: space-between;
					flex-wrap: wrap;
					grid-gap: 10px;
					margin-bottom: 5px;
				}
			}

			&__send-btn {
				padding: 7px 10px !important;
			}
		}
	}

	&__auto-sending {
		border-top: #e4e4e4 1px solid;
		padding-top: 15px;
	}
}
</style>
